module.exports = __webpack_public_path__ + "static/img/7.2d3548b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/7.png
// module id = GSyZ
// module chunks = 0